<template>
  <div>
    <div class="container">
      <Bread :list="breadList" class="ma-t-30" />
      <div class="ma-t-30">
        <div class="flex f-between">
          <img
            :src="detail.Image"
            alt=""
            srcset=""
            width="550"
            height="350"
            class="img_cover b-r-15 b-5-red"
          />
          <div class="flex1 pa-l-20 flex flex-direction">
            <div class="fon-30 font-bold">
              {{ detail.ActivityName }}
            </div>
            <div class="font-bold ma-t-20">
              展映时间：{{ detail.StartTime }} - {{ detail.EndTime }}
            </div>
            <div class="ma-t-20">
              {{ detail.Summary }}
            </div>
            <div class="flex1 flex f-align-end">
              <div class="flex f-between f-center width100 ma-t-20">
                <div>
                  <span class="font-bold">观影卷</span>
                  <span class="font-bold c-red fon-20 pa-lr-10"
                    >￥{{ detail.Price }}</span
                  >
                  <span class="c-666">已有 {{ detail.BuyCount }} 人购买</span>
                </div>
                <div class="btn-buy" v-if="detail.IsBuy">已购买</div>
                <div class="btn-buy c-p" v-else @click="buy">购券观看</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="menu-item fon-24 ma-t-80">
        <div class="font-bold">在线观看</div>
        <div class="font-bold">Watch online</div>
        <img
          src="../img/index/index21.png"
          class="item-right"
          alt=""
          srcset=""
        />
        <img
          src="../img/index/index22.png"
          class="item-left"
          alt=""
          srcset=""
        />
      </div>

      <div>
        <div class="flex f-jcenter b-b-1-e3 t-center">
          <div
            class="ma-r-20 pa-tb-20 c-p"
            :class="{ 'tab-active': tabActive == 0 }"
            @click="tabActive = 0"
          >
            参展作品
          </div>
          <div
            class="ma-l-20 pa-tb-20 c-p"
            :class="{ 'tab-active': tabActive == 1 }"
            @click="tabActive = 1"
          >
            详细介绍
          </div>
        </div>
      </div>
      <div class="ma-t-80 pa-b-40">
        <!-- 参展作品 -->
        <div v-if="tabActive == 0">
          <div class="flex f-wrap width100 f-between">
            <div
              class="width48 flex ma-b-60"
              v-for="(item, index) in detail.MovieList"
              :key="index"
            >
              <img
                :src="item.Image"
                alt=""
                width="200"
                height="300"
                class="img_cover b-r-15"
              />
              <div class="flex1 flex flex-direction f-between pa-10">
                <div class="height10 font-bold">{{ item.Name }}</div>
                <div class="height190px ma-t-10 c-666" :title="item.Summary">
                  {{ item.Summary }}
                </div>
                <div class="height10 flex f-around ma-t-10">
                  <div class="btn-hollow c-p" @click="toPage('detail',item)">详细介绍</div>
                  <div class="btn-solid c-p" @click="onlineWatch(item.Video)">在线观看</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 详细介绍 -->
        <div v-if="tabActive == 1">
          <div class="li-html" v-html="detail.Content"></div>
        </div>
      </div>
    </div>

    <!-- 支付弹框二维码 -->
    <el-dialog
      :visible.sync="paydialogVisible"
      width="30%"
      @before-close="paydialogVisible=false"
    >
      <div>
        <payment :payKey="payKey" @paySuccess="paySuccess" v-if="paydialogVisible"></payment>
      </div>
    </el-dialog>

    <el-dialog 
     :visible.sync="videodialogVisible"
      width="50%"
      @before-close="videodialogVisible=false"
      :destroy-on-close="true">
      <video :src="videoUrl" controls class="width100"></video>
    </el-dialog>

    <div class="middle" v-show="iscontent" @click="iscontent=false">
      <div class="middle1" v-html="content" @click.stop="iscontent=true"></div>
    </div>
  </div>
</template>

<script>
  import { getShowingDetail, getShowingBuy } from "../api.js";
  import payment from "../components/payment.vue";
  export default {
    components:{
      payment
    },
    data() {
      return {
        breadList: [
          {
            name: "点播平台",
            path: "/vod/index",
          },
          {
            name: "详情",
            path: "",
          },
        ],
        tabActive: 0,
        id: 0,
        siteId:"",
        detail: {},
        paydialogVisible:false,//是否显示支付弹框
        payKey:'',
        videoUrl:'',
        videodialogVisible:false,
        content:"",
        iscontent:false,
      };
    },
    activated() {
      this.id = this.$route.query.id;
      this.siteId=this.$route.query.siteId;
      this.loadData();
      
    
    },
    methods: {
      loadData() {
        getShowingDetail({ activityId: this.id,siteId:this.siteId }).then((res) => {
          this.detail = res.data.Data;
        });
      },
      //下单购买
      buy() {
        getShowingBuy({ ActivityId: this.id, Count: 1 }).then(res=>{
          this.payKey=res.data.Data.Key
          this.paydialogVisible=true
        });
      },
      //支付成功
      paySuccess(){
        this.paydialogVisible=false
        this.loadData()
      },
      //在线观看
      onlineWatch(url){
        if(!this.detail.IsBuy){
          this.$message.error("请先购买");
          return 
        }
        this.videodialogVisible=true;
        this.videoUrl=url
      },
      toPage(type,e){
        if(type=="detail"){
          this.iscontent=true;
          this.content=e.Content.replace(/<img/g,"<img mode='widthFix' style='width: 100%;vertical-align: middle;height: auto;'");
        }
      }
    },
  };
</script>

<style lang="scss" scoped>
  .menu-item {
    position: relative;
    .item-right {
      position: absolute;
      right: 0;
      top: 0;
    }
    .item-left {
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .btn-buy {
    width: 198px;
    height: 67px;
    text-align: center;
    line-height: 67px;
    background: #fb004d;
    color: #fff;
    border-radius: 34px;
  }
  .b-5-red {
    border: 5px solid #fb004d;
  }

  .tab-active {
    border-bottom: 3px solid #fb004d;
    font-weight: bold;
  }

  .btn-hollow,
  .btn-solid {
    width: 119px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    border: 1px solid #fb004d;
    border-radius: 20px;
  }
  .btn-hollow {
    color: #fb004d;
  }
  .btn-solid {
    background: #fb004d;
    color: #fff;
  }
  .height190px {
    height: 190px;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 9;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }
  .width48 {
    width: 48%;
  }
  .middle {
    position: fixed;
    bottom: 0;
    right: 0;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    z-index: 999;
}

.middle1 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    width: 50%;
    background-color: #fff;
    border-radius: 6px;
    height:700px;
    overflow:auto;
    padding:20px;
}


</style>